import { CountryCode } from "@redotech/redo-inventory-common/shopify-listing/common-schemas";

/**
 * Normalize a raw country value to an ISO 3166-1 alpha-2 code (uppercase),
 * e.g. "ca" -> "CA". Returns undefined when the value is empty or not a
 * recognized country code, so callers can drop unexpected data rather than
 * persisting it.
 */
export function normalizeCountryCode(
  raw: string | null | undefined,
): string | undefined {
  if (!raw) {
    return undefined;
  }
  const code = raw.trim().toUpperCase();
  return code in CountryCode ? code : undefined;
}

const UNITED_STATES_COUNTRY_VALUES = new Set([
  "US",
  "USA",
  "UNITED STATES",
  "UNITED STATES OF AMERICA",
]);

export function isUnitedStatesCountry(country?: string): boolean {
  return UNITED_STATES_COUNTRY_VALUES.has(country?.trim().toUpperCase() ?? "");
}

const ISO_639_1 = /^[a-z]{2}$/;

/**
 * Normalize a raw language value to an ISO 639-1 code (lowercase, region
 * stripped), e.g. "fr-CA" -> "fr". Returns undefined when the value is empty or
 * not a well-formed language code, so callers can drop unexpected data (full
 * locale names, region tags, etc.) rather than persisting it.
 */
export function normalizeLanguageCode(
  raw: string | null | undefined,
): string | undefined {
  if (!raw) {
    return undefined;
  }
  const [code] = raw.trim().toLowerCase().split(/[-_]/);
  return code && ISO_639_1.test(code) ? code : undefined;
}
